import React from "react";
import { Link } from "react-router-dom";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";

import Page from "../../components/page/Page";
import styles from "./style.module.scss";

export const Error404: React.FC = () => {
    const title = "Error page";

    return (
        <Page
            type="page"
            title={title}
            description={" "}
            hasBreadcrumbs={true}
            className={styles.error404}
        >
            <Column height="500px" heights="fit" alignmentHorizontal="center">
                <Text type="d300">404</Text>
                <Alert type="error">This page does not exist.</Alert>
                <Box>
                    <Link to="/">Go back to the homepage</Link>
                </Box>
            </Column>
        </Page>
    );
};
